import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { StorageService } from '../storage.service';
import 'rxjs/add/operator/do';
import 'rxjs/add/observable/throw';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private helper: TokenHelper;

    constructor(
        private storage: StorageService,
    ) { 
        this.helper = new TokenHelper(storage);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const header = this.helper.getTokenHeader();
        if (header) {
            request = request.clone({
                setHeaders: header
            });
        }

        return next.handle(request)
            .catch((err: any, caught) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 403) {
                        this.storage.clear();
                    }

                    return Observable.throw(err);
                }
            });
    }
}

@Pipe({
    name: 'secureImage'
})
export class SecureImagePipe implements PipeTransform {
    private helper: TokenHelper;

    constructor(
        private http: HttpClient,
        private sanitizer: DomSanitizer,
        storage: StorageService) { 
            this.helper = new TokenHelper(storage);
        }
        
        transform(url): Observable<SafeUrl> {
            const headers =  this.helper.getTokenHeader();
            
            return this.http
                .get(url, { responseType: 'blob', headers })
                .map(val => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val)));
        }
}

class TokenHelper {
    constructor(private storage: StorageService) {}
    
    public getTokenHeader(): any {
        if (this.storage.isSensitiveDataExist.value) {
            const token = this.storage.getToken();
    
            if (token) {
                return {
                    Authorization: `Bearer ${token}`
                };
            }
        }

        return {};
    }
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/providers/token.interceptor.ts